import { Link } from 'react-router-dom';
import { SygeforsikringDanmarkLogo } from './SygeforsikringDanmark';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white text-[#33483B] pt-16 pb-12 border-t border-[#E2DAD0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          
          {/* Col 1: Brand & CVR */}
          <div className="space-y-4">
            <h3 className="font-serif text-2xl font-bold text-[#5f7365] tracking-wide">
              Din Privat Psykolog
            </h3>
            <div className="pt-1 text-xs text-[#576B5F] space-y-3">
              <p>Autoriseret af Psykolognævnet / Styrelsen for Patientsikkerhed</p>
              
              {/* Sygeforsikringen "danmark" link */}
              <div className="pt-2 border-t border-[#EAE3D5]">
                <div className="flex items-stretch gap-3">
                  <div className="shrink-0 bg-white p-1 rounded flex items-center justify-center">
                    <a 
                      href="https://www.sygeforsikring.dk" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      title="Gå til Sygeforsikringen &quot;danmark&quot; (åbner i et nyt vindue)"
                      className="h-full flex items-center hover:opacity-90 transition-opacity"
                    >
                      <img 
                        src="/cdn-cgi/image/width=160,quality=85,format=auto/_assets/image_400e7d92.png" 
                        alt="Sygeforsikringen &quot;danmark&quot; logo" 
                        className="h-full max-h-[46px] w-auto object-contain"
                      />
                    </a>
                  </div>
                  <Link to="/priser" className="group flex flex-col justify-center" title="Læs om tilskud fra Sygeforsikringen &quot;danmark&quot;">
                    <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#5f7365] group-hover:underline">
                      Tilskud fra &quot;danmark&quot;
                    </span>
                    <p className="text-[11px] text-[#576B5F] mt-0.5 leading-tight">
                      Få 300 kr. i tilskud pr. session. Læs mere på prisoversigten →
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Col 2: Kontaktoplysninger & CTA */}
          <div className="space-y-4">
            <h4 className="font-serif text-lg font-semibold text-[#5f7365]">
              Kontaktoplysninger
            </h4>
            <ul className="space-y-3 text-sm text-[#3A4D42]">
              <li className="flex items-start gap-3">
                <i className="fa-regular fa-location-dot text-[#5f7365] mt-1 shrink-0" aria-hidden="true" />
                <div>
                  <p className="font-medium text-[#5f7365]">Privatklinikken</p>
                  <p>Torvegade 8, 1. sal</p>
                  <p>6510 Gram</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-phone text-[#5f7365] shrink-0" aria-hidden="true" />
                <a 
                  href="tel:29921879" 
                  className="hover:text-[#4e6053] font-medium transition-colors whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">29 92 18 79</span>
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-envelope text-[#5f7365] shrink-0" aria-hidden="true" />
                <a 
                  href="mailto:kontakt@dinprivatpsykolog.dk" 
                  className="hover:text-[#4e6053] transition-colors whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">kontakt@dinprivatpsykolog.dk</span>
                </a>
              </li>
              <li className="flex items-start gap-3 pt-1">
                <i className="fa-regular fa-clock text-[#5f7365] mt-1 shrink-0" aria-hidden="true" />
                <div>
                  <p className="font-medium text-[#5f7365] text-xs uppercase tracking-wider">Telefontid</p>
                  <p className="text-xs text-[#576B5F]">12.45 - 13.00 hverdage (undtagen onsdage)</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Col 3: Navigation & Sider */}
          <div className="space-y-4">
            <h4 className="font-serif text-lg font-semibold text-[#5f7365]">
              Hurtig navigation
            </h4>
            <ul className="grid grid-cols-2 gap-2 text-sm text-[#3A4D42]">
              <li>
                <Link to="/" className="hover:text-[#4e6053] transition-colors inline-flex items-center gap-1.5">
                  <i className="fa-regular fa-angle-right text-[10px] text-[#5f7365]" aria-hidden="true" />
                  Hjem
                </Link>
              </li>
              <li>
                <Link to="/terapi/samtaleterapi" className="hover:text-[#4e6053] transition-colors inline-flex items-center gap-1.5">
                  <i className="fa-regular fa-angle-right text-[10px] text-[#5f7365]" aria-hidden="true" />
                  Terapi
                </Link>
              </li>
              <li>
                <Link to="/udtalelser" className="hover:text-[#4e6053] transition-colors inline-flex items-center gap-1.5">
                  <i className="fa-regular fa-angle-right text-[10px] text-[#5f7365]" aria-hidden="true" />
                  Udtalelser
                </Link>
              </li>
              <li>
                <Link to="/om" className="hover:text-[#4e6053] transition-colors inline-flex items-center gap-1.5">
                  <i className="fa-regular fa-angle-right text-[10px] text-[#5f7365]" aria-hidden="true" />
                  Om Marie
                </Link>
              </li>
              <li>
                <Link to="/klinikken" className="hover:text-[#4e6053] transition-colors inline-flex items-center gap-1.5">
                  <i className="fa-regular fa-angle-right text-[10px] text-[#5f7365]" aria-hidden="true" />
                  Klinikken
                </Link>
              </li>
              <li>
                <Link to="/priser" className="hover:text-[#4e6053] transition-colors inline-flex items-center gap-1.5">
                  <i className="fa-regular fa-angle-right text-[10px] text-[#5f7365]" aria-hidden="true" />
                  Priser
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-[#4e6053] transition-colors inline-flex items-center gap-1.5">
                  <i className="fa-regular fa-angle-right text-[10px] text-[#5f7365]" aria-hidden="true" />
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/cv" className="hover:text-[#4e6053] transition-colors inline-flex items-center gap-1.5">
                  <i className="fa-regular fa-angle-right text-[10px] text-[#5f7365]" aria-hidden="true" />
                  CV
                </Link>
              </li>
              <li>
                <Link to="/velkomstbrev" className="hover:text-[#4e6053] transition-colors inline-flex items-center gap-1.5">
                  <i className="fa-regular fa-angle-right text-[10px] text-[#5f7365]" aria-hidden="true" />
                  Info / Praksis
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Erhvervspsykolog & Praktisk */}
          <div className="space-y-4">
            <h4 className="font-serif text-lg font-semibold text-[#5f7365]">
              Praktisk
            </h4>
            
            {/* HumanEye link */}
            <div className="text-xs text-[#3A4D42] space-y-1.5">
              <p className="text-[#576B5F] font-medium">Erhvervspsykolog:</p>
              <a 
                href="http://www.humaneye.dk/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-[#5f7365] hover:text-[#4e6053] font-semibold hover:underline transition-colors"
              >
                <i className="fa-regular fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
                humaneye.dk
              </a>
              <p className="text-[12px] text-[#576B5F] leading-relaxed">
                Marie tilbyder også erhvervspsykologiske ydelser, ledelses- og medarbejderudvikling gennem HumanEye.
              </p>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#E8E2D9] flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#576B5F]">
          <p>
            Copyright © Din Privat Psykolog v/ Marie Aagaard Larsen {currentYear} • CVR: 30132025
          </p>
          <div className="flex items-center gap-4">
            <span>Torvegade 8, 6510 Gram</span>
            <span>•</span>
            <a href="tel:29921879" className="hover:text-[#4e6053] transition-colors whitespace-nowrap">
              <span className="whitespace-nowrap">Tlf: 29 92 18 79</span>
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
